module.exports = __webpack_public_path__ + "img/mit.430dbab0.png";